import occupationApi from './api/occupationApi';

export const OCCUPATION_INSERT = 'occupation/INSERT';
export const OCCUPATION_LIST = 'occupation/LIST';

const initialState = {
	data: null,
}

export default (state = initialState, action) => {
	switch (action.type) {
		case OCCUPATION_LIST:
			return {
				...state,
				data: action.payload
			};
		default:
			return state;
		
	}
};

export const occupationInsert = (payload) => {
	return dispatch => {
		return occupationApi.OccupationInsert(payload).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const occupationUpdate = (payload, id) => {
	return dispatch => {
		return occupationApi.OccupationUpdate(payload, id).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const occupationList = () => {
	return dispatch => {
		return occupationApi.OccupationList().then(data => {
			dispatch({
				type: OCCUPATION_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const occupationDelete = (id) => {
	return dispatch => {
		return occupationApi.OccupationDelete(id).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};